<ng-container *ngFor="let message of messages">
    <u2b-message [type]="message.type || 'info'" [customClass]="(message.customClass || '')" [noMargin]="true">
        <div [innerHTML]="message.trustedContent" class="message-content"></div>
    </u2b-message>
</ng-container>
